import CurvedLoop from './CurvedLoop';
import DecryptedText from './DecryptedText';
import styled from 'styled-components';
import HeavenGrid from '../img/heaven_grid.png';
import "y2k-css/dist/y2k.css";

export default function TourDate({loopingText="HYPERPUP @ FWA 2026", title="Something", location="Somewhere", timedate="Sometime", isTicketed=true, isSoldOut=false}) {
    const isTouchScreen = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    const Card = styled.div `
    padding: 20px;
    width: min(calc(100% - 20px), 500px);
    height: 200px;
    position: relative;
    overflow: hidden;
    border-radius: 20px;
    font-family: '5dots';
    background: url(${HeavenGrid});
    color: #3a3a3a;
    flex: 1 1 min(calc(100% - 20px), 500px);

    @media (max-width: 700px) {
    height: 150px;
    }
    `

    const UnderCurve = styled.div `
    z-index: 900;
    position: relative;
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: space-between;
    flex-direction: column;
    `

    const TopAlign = styled.div `
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    `

    const BottomAlign = styled.div `
    margin-top: auto;
    align-self: flex-start;
    z-index: 1000;
    position: relative;
    `
    return (
        <Card>
            <CurvedLoop marqueeText={loopingText} curveAmount={500} interactive={false} speed={isTouchScreen ? 8 : 2}/>
            <CurvedLoop alt={true} marqueeText="♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪ ♫ ♪" offset={0} curveAmount={-700} interactive={false} speed={isTouchScreen ? 8 : 2}/>
            
            <UnderCurve>
                <TopAlign>
                    <DecryptedText text={title} style={{fontFamily: "isobold", fontSize: "20pt", lineHeight: ""}} maxIterations={10} animateOn="view" /><br/>
                    <DecryptedText text={`${timedate} // ${location}`} style={{fontFamily: "montsera", fontSize: "19pt"}} maxIterations={10} animateOn="view" />
                </TopAlign>
                <BottomAlign>
                    {isTicketed ? <button className="retro-button-default" style={{fontFamily: "bytebounce", fontSize: "12pt"}}>Buy Tickets</button> : <button className="retro-button-default" style={{fontFamily: "bytebounce", fontSize: "12pt"}} disabled={true}>Free Event</button> }
                </BottomAlign>
            </UnderCurve>
        </Card>
    )
}